export const VITE_SHEET_TOKEN = import.meta.env.VITE_SHEET_TOKEN;

export const LOAN_PURPOSE_PERSONAL = "Personal";
export const LOAN_PURPOSE_BUSINESS = "Business";
export const EMP_STAT_SELF_EMPLOYED = "Self-employed";

// Initialised loan types
export const ALL_LOAN_TYPES =
	"Car Loan,Boat Loan,Caravan Loan,Truck Loan,Equipment Loan,Motorcycle Loan,Personal Loan,Business Loan";
export const LOAN_TYPE_PERSONAL = "Personal Loan";
export const LOAN_TYPE_BUSINESS = "Business Loan";
export const LOAN_TYPE_CAR = "Car Loan";
export const LOAN_TYPE_BOAT = "Boat Loan";
export const LOAN_TYPE_BIKE = "Bike Loan";
export const LOAN_TYPE_MOTORCYCLE = "Motorcycle Loan";
export const LOAN_TYPE_CARAVAN = "Caravan Loan";
export const LOAN_TYPE_TRUCK = "Truck Loan";
export const LOAN_TYPE_EQUIPMENT = "Equipment Loan";
export const BOAT_ASSET_TYPE_COMMERCIAL = "Commercial Boat";
export const ABN_STATUS_NEW_ABN = "New Business ABN";

// Assets used in partner pages
export const ASSET_TYPE_CAR = "Cars";
export const ASSET_TYPE_CARAVAN = "Caravans";
export const ASSET_TYPE_TRUCK = "Trucks";
export const ASSET_TYPE_EQUIPMENT = "Equipment";
export const ASSET_TYPE_BEAUTY = "Beauty Equipment";
export const ASSET_TYPE_BIKE = "Bikes";
export const ASSET_TYPE_BOAT = "Boats";
export const ASSET_TYPE_PERSONAL = "Personal";
export const LOANTYPES_WLOANPURPOSE = [ASSET_TYPE_CAR, ASSET_TYPE_BOAT];

export const loanSecurityType = [
	{ id: "Secured", title: "Secured" },
	{ id: "Unsecured", title: "Unsecured" },
	{ id: "Green", title: "Green" },
];

export const paymentFrequency = [
	{ id: 1, title: "Weekly" },
	{ id: 2, title: "Fortnightly" },
	{ id: 3, title: "Monthly" },
];

export const maxBalloonPercentage: { [key: number]: number } = {
	1: 0.5,
	2: 0.5,
	3: 0.5,
	4: 0.45,
	5: 0.4,
	6: 0.35,
	7: 0.3,
};

export const JadeSites = [
	"jade.finance",
	"jadefinance.au",
	"jadetruckloans.com.au",
	"jadebikeloans.com.au",
	"jadeboatloans.com.au",
	"jadecaravanfinance.com.au",
	"jadecarloans.com.au",
	"jadeequipmentfinance.com.au",
	"jadeagrifinance.com.au",
];

export const EasySites = [
	"easypersonalloans.com.au",
	"easyboatloans.com.au",
	"easycaravanfinance.com.au",
	"easytruckfinance.com.au",
	"easyequipmentfinance.com.au",
	"easycarfinance.au",
];

export const YesSites = [
	"yesboatloans.com.au",
	"yescarloans.com.au",
	"yescaravanloans.com.au",
	"yesequipmentloans.com.au",
	"yestruckloans.com.au",
	"yeshomeloans.com.au",
];

// Color Theme Settings
export const appSettingsConfig: Record<string, Record<string, string>> = {
	"Jade Finance": {
		calcType: "Business",
		themeColor: "#19cc76",
		themeColorLight: "#00EB89",
		themeColorDark: "#022813",
		hoverColor: "#16ac6b",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#0f273e",
	},
	"Jade Boat Loans": {
		calcType: "Business",
		themeColor: "#3885e2",
		themeColorLight: "#88C0FE",
		themeColorDark: "#143051",
		hoverColor: "#3c6fe7",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#0f273e",
	},
	"Jade Car Loans": {
		calcType: "Business",
		themeColor: "#dc1912",
		themeColorLight: "#88C0FE",
		themeColorDark: "#143051",
		hoverColor: "#c51a14",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#0f273e",
	},
	"Jade Caravan Finance": {
		calcType: "Business", //For Jade Caravans Only.
		themeColor: "#ff8300",
		themeColorLight: "#FFDCB4",
		themeColorDark: "#824300",
		hoverColor: "#f77300",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#0f273e",
	},
	"Jade Equipment Finance": {
		calcType: "Business",
		themeColor: "#069d2c",
		themeColorLight: "#B9FFAE",
		themeColorDark: "#022B0C",
		hoverColor: "#068026",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#0f273e",
	},
	"Jade Truck Loans": {
		calcType: "Business",
		themeColor: "#ffc913",
		themeColorLight: "#FFF9B0",
		themeColorDark: "#8A6C0A",
		hoverColor: "#e9b814",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#0f273e",
	},
	"Jade Bike Loans": {
		calcType: "Business",
		themeColor: "#0e8fbe",
		themeColorLight: "#C8ECFF",
		themeColorDark: "#074E68",
		hoverColor: "#0d7ea7",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#0f273e",
	},
	"Easy Boat Loans": {
		calcType: "Personal",
		themeColor: "#2192ff",
		themeColorLight: "#C8ECFF",
		themeColorDark: "#074E68",
		hoverColor: "#1f7fd8",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#0e2439",
	},
	"Easy Caravan Finance": {
		calcType: "Personal",
		themeColor: "#FF7B27",
		themeColorLight: "#FFD7B7",
		themeColorDark: "#6D3410",
		hoverColor: "#F55C00",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#142F48",
	},
	"Easy Equipment Finance": {
		calcType: "Business",
		themeColor: "#FFAD00",
		themeColorLight: "#FFECC1",
		themeColorDark: "#6D4B00",
		hoverColor: "#ECA200",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#142F48",
	},
	"Easy Truck Finance": {
		calcType: "Business",
		themeColor: "#fccc00",
		themeColorLight: "#FFF9BE",
		themeColorDark: "#4E3F00",
		hoverColor: "#eabb00",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#181754",
	},
	"Easy Car Finance": {
		calcType: "Business",
		themeColor: "#d24242",
		themeColorLight: "#FFE0D5",
		themeColorDark: "#3F1414",
		hoverColor: "#b53838",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#242d42",
	},
	"Easy Personal Loans": {
		calcType: "Personal",
		themeColor: "#a6c36f",
		themeColorLight: "#D5FFC9",
		themeColorDark: "#29301B",
		hoverColor: "#839e51",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#1d342e",
	},
	"Yes Home Loans": {
		calcType: "Mortgage",
		themeColor: "#FFAA22",
		themeColorLight: "#FFF8EB",
		themeColorDark: "#523408",
		hoverColor: "#F69D0E",
		secondaryColor: "#114EDD",
		secondaryColorLight: "#E2E9FE",
		secondaryColorDark: "#061B4C",
		themeHeaderTxt: "#142F48",
		breakdownBG: "#023BA6",
	},
	"Jade Agri Finance": {
		calcType: "Business",
		themeColor: "#19cc76",
		themeColorLight: "#00EB89",
		themeColorDark: "#022813",
		hoverColor: "#16ac6b",
		secondaryColor: "#0f273e",
		secondaryColorLight: "#3283CF",
		secondaryColorDark: "#081420",
		themeHeaderTxt: "#142f48",
		breakdownBG: "#0f273e",
	},
};
